"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var _selectSku = _interopRequireDefault(require("../../../business/supplier/coupons/selectSku.vue"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SelectSku: _selectSku.default
  },
  data: function data() {
    return {
      meatLists: [{
        selectProduct: [],
        selectNum: null,
        comboName: ''
      }]
    };
  },
  props: {
    value: Array,
    initOption: Array
  },
  watch: {
    value: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.meatLists = val.length ? val : [{
          selectProduct: [],
          selectNum: null,
          comboName: ''
        }];
      },
      immediate: true,
      deep: true
    },
    initOption: {
      handler: function handler() {
        var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        this.meatLists = val.length ? val : [{
          selectProduct: [],
          selectNum: null,
          comboName: ''
        }];
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    changeVal: function changeVal() {
      this.$emit("input", this.meatLists);
    },
    getMealVal: function getMealVal() {
      return this.meatLists;
    },
    removeMeat: function removeMeat(i) {
      this.meatLists.splice(i, 1);
    },
    handlerDelete: function handlerDelete(i, id) {
      if (this.meatLists[i] && this.meatLists[i].selectProduct && this.meatLists[i].selectProduct.length) {
        var removeIdx = this.meatLists[i].selectProduct.findIndex(function (item) {
          return item.id == id;
        });
        removeIdx != -1 && this.meatLists[i].selectProduct.splice(removeIdx, 1);
      }
      ;
    },
    modalPicTap: function modalPicTap(tit, i) {
      var _this = this;
      this.$modalUpload(function (img) {
        _this.mealImg = img[0].sattDir;
        _this.$set(_this.meatLists[i], 'image', img[0].sattDir);
      }, tit, 'system');
    },
    removeImg: function removeImg(i) {
      this.$set(this.meatLists[i], 'image', '');
    }
  }
};